var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelmet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 32,
    viewBox: "0 0 49 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xC3\x8Dcone Capacete"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.9782 30.9423H3.64936C2.41052 30.9423 1.40039 29.9321 1.40039 28.6933V28.6933C1.40039 27.4545 2.41052 26.4443 3.64936 26.4443H33.4196",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M36.0327 26.4636H45.3526C46.5914 26.4636 47.6015 27.4737 47.6015 28.7126C47.6015 29.9514 46.5914 30.9615 45.3526 30.9615H14.6484",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M36.7682 6.03861C36.8629 5.35037 36.3817 4.71572 35.6934 4.62108C35.0052 4.52643 34.3705 5.00764 34.2759 5.69588L32.596 17.9121C32.5013 18.6004 32.9825 19.235 33.6708 19.3297C34.359 19.4243 34.9937 18.9431 35.0883 18.2548L36.7682 6.03861Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M15.6757 12.7029L16.3809 17.887C16.4762 18.5731 15.9997 19.2211 15.2945 19.3164C14.6084 19.4117 13.9604 18.9352 13.8651 18.2301L12.1879 6.03226C12.0926 5.34614 12.5691 4.69813 13.2743 4.60284C13.9604 4.50754 14.6084 4.98402 14.7037 5.6892L15.2564 9.71066",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M24.7296 20.25H24.3675C22.5569 20.25 21.0322 18.8587 20.8797 17.0671L19.5646 2.33449C19.5074 1.62931 20.0602 1.03848 20.7463 1.03848H28.3508C29.056 1.03848 29.6087 1.64836 29.5325 2.33449L28.2174 17.0671C28.065 18.8777 26.5402 20.25 24.7296 20.25Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M14.7793 6.2222C16.2468 5.44078 17.8478 4.84995 19.6203 4.44971",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M4.14258 26.4634C4.14258 19.221 6.8299 11.9786 12.4523 7.7284",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M34.1999 6.10831C34.1999 6.10831 34.0474 6.03208 33.9712 5.99396C32.5799 5.25066 31.0361 4.67888 29.3398 4.27864",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M44.6279 26.0632C44.6279 18.9732 42.0168 11.8832 36.5469 7.65212",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelmet);
export default __webpack_public_path__ + "static/media/Helmet.95778c6a5c6c163d6f078e8ff5e67c24.svg";
export { ForwardRef as ReactComponent };